const VacationCategoryComponent = () => import('@/views/hrm/VacationCategory/VacationCategoryView')

export default [
    {
        path:'/VacationCategoryIndex',
        name:'VacationCategoryComponent',
        component:VacationCategoryComponent
    }
]